import React, { useState } from 'react';

export default function Meeting(props) {
  const { history } = props;

  const [data, setData] = useState();

  return null;
}
